<template>
    <b-modal :active="display" :can-cancel="true" aria-role="alertdialog" @close="display = false">
        <template>
            <div class="card-content text-dark">
                <div class="modal-header">
                    <h5 class="modal-title">Export des soldes clients</h5>
                </div>
                <div class="is-flex is-flex-direction-column modal-body" style="min-height: 500px">
                    <div class="w-100 is-flex is-flex-direction-row is-justify-content-space-around flex-grow-1">
                        <b-field label="Date début">
                            <b-datepicker placeholder="Click to select..." v-model="startDate"></b-datepicker>
                        </b-field>

                        <b-field label="Date fin">
                            <b-datepicker placeholder="Click to select..." v-model="endDate"></b-datepicker>
                        </b-field>
                    </div>

                    <div class="w-100 d-flex justify-content-center" @click.prevent="doDownload">
                        <button class="btn btn-secondary">
                            <i v-show="loading" class="fas fa-circle-notch fa-spin mr-1" />
                            Télécharger
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
    import Download from '@/utils/download'
    import exportCsv from '@/api/v2/export/exportCsv'
    import { datePickerMixin } from '@/mixins/datePickerMixin'
    import store from '@/store'

    export default {
        name: 'OrdersExport',
        components: {},
        data: function () {
            return {
                loading: false,
                display: false
            }
        },
        mixins: [datePickerMixin],
        methods: {
            open() {
                this.display = true
            },

            doDownload() {
                this.loading = true
                exportCsv
                    .downloadCsvBalanceUsers(this.startDate, this.endDate)
                    .then(response => Download.download(
                        response,
                        response.headers['content-disposition'].match(/filename="(.*)"/)[1]
                    ))
                    .catch(e => store.dispatch('toastError', e))
                    .finally(() => this.loading = false)
            }
        }
    }
</script>
